'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

require('./Category.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    CategoryView: {
        displayName: 'CategoryView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Category/default/CategoryView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var CategoryView = _wrapComponent('CategoryView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(CategoryView, _Component);

    function CategoryView(props) {
        (0, _classCallCheck3.default)(this, CategoryView);
        return (0, _possibleConstructorReturn3.default)(this, (CategoryView.__proto__ || (0, _getPrototypeOf2.default)(CategoryView)).call(this, props));
    }

    (0, _createClass3.default)(CategoryView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                activePage = _props.activePage,
                limit = _props.limit,
                count = _props.count,
                products = _props.products,
                sliderContent = _props.sliderContent,
                title = _props.title,
                orderInOneClick = _props.orderInOneClick,
                buyInCreditActive = _props.buyInCreditActive,
                lang = _props.lang,
                picture = _props.picture,
                description = _props.description;


            var body = null;

            if (products.length === 0) {
                body = _react3.default.createElement(
                    'h3',
                    null,
                    lang['store.category.nothing_found']
                );
            } else {
                body = _react3.default.createElement(_components2.Paginator, {
                    activePage: activePage,
                    limit: limit,
                    count: count,
                    handleChangePage: this.props.handleChangePage
                });
            }
            return _react3.default.createElement(
                'div',
                { className: 'tab-pane active category_container', id: 'featured' },
                _react3.default.createElement(
                    'ul',
                    null,
                    picture ? _react3.default.createElement(
                        'li',
                        { style: { verticalAlign: 'middle' }, className: 'category-picture' },
                        _react3.default.createElement('img', { src: picture, alt: '', style: { maxHeight: '110px' } })
                    ) : null,
                    _react3.default.createElement(
                        'li',
                        { style: { verticalAlign: 'middle', paddingLeft: '0px', display: 'inline-block' } },
                        _react3.default.createElement(
                            'h1',
                            null,
                            title
                        )
                    )
                ),
                description ? _react3.default.createElement(
                    'div',
                    { style: { marginBottom: '22px', marginTop: '37px' } },
                    _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: description } })
                ) : null,
                sliderContent && sliderContent.length > 0 ? _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'h2',
                        { className: 'best_sailers_header text-theme' },
                        lang['store.category.recommended']
                    ),
                    _react3.default.createElement(_components2.GoodsSlider, {
                        items: sliderContent,
                        count: 3,
                        contentType: "product",
                        orderInOneClick: orderInOneClick,
                        buyInCreditActive: buyInCreditActive
                    })
                ) : null,
                _react3.default.createElement(
                    _components2.Preloader,
                    { preload: this.props.preload },
                    _react3.default.createElement(_components2.Products, { products: products })
                ),
                body
            );
        }
    }]);
    return CategoryView;
}(_react2.Component), _class.defaultProps = {
    preload: false
}, _class.propTypes = {
    title: _react2.PropTypes.string,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = CategoryView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Category/default/CategoryView.jsx
// module id = 1807
// module chunks = 0